import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const formatApiError = (e) => {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (typeof d?.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  return "Something went wrong. Please try again.";
};

export const imgSrc = (url) =>
  !url ? "" : url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;

export default api;
